import { Injectable } from '@angular/core';
/**
 * @hidden
 */
var FocusRoot = /** @class */ (function () {
    function FocusRoot() {
        this.groups = [];
    }
    FocusRoot.prototype.registerGroup = function (group) {
        this.unregisterGroup(group);
        this.groups.push(group);
    };
    FocusRoot.prototype.unregisterGroup = function (group) {
        this.groups = this.groups.filter(function (f) { return f !== group; });
    };
    FocusRoot.prototype.activate = function () {
        this.groups.forEach(function (f) { return f.activate(); });
    };
    FocusRoot.prototype.deactivate = function () {
        this.groups.forEach(function (f) { return f.deactivate(); });
    };
    FocusRoot.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    FocusRoot.ctorParameters = function () { return []; };
    return FocusRoot;
}());
export { FocusRoot };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/navigation/focus-root.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/navigation/focus-root.js
// module chunks = vendor